import { get, post, put, destroy } from '@/api/request';

function inviteUser({ appId, data }) {
  return post(`/apps/${appId}/user_memberships`, data);
}

function validateInvitationToken(token) {
  return get(`/user_memberships/validate_invitation_token/${token}`);
}

function acceptInvitation(data) {
  return post('/invitations', data);
}

function resendInvitation(id) {
  return put(`/user_memberships/${id}/resend_invitation`);
}

function removeUserMembership(id) {
  return destroy(`/user_memberships/${id}`);
}

function updateRole(id, data) {
  return put(`/user_memberships/${id}/update_role`, data);
}

export default {
  inviteUser,
  validateInvitationToken,
  acceptInvitation,
  resendInvitation,
  removeUserMembership,
  updateRole,
};



// WEBPACK FOOTER //
// ./src/store/modules/userMembership/api.js